import React from 'react';
import HeroSlider from '../components/HeroSlider.jsx';
import ThreeSDealership from '../components/ThreeSDealership.jsx';
import VideoSection from '../components/VideoSection.jsx';
import Banner from '../components/banner.jsx';
import Headline from '../components/headline.jsx';
// import Trucks from '../../src/components/carosol.jsx'
import Reviews from '../components/reviews.jsx';
import Brands from '../components/brands.jsx';
import TrucksList from '../components/TruckList.jsx';
// import Fabricate from '../components/fabrication.jsx'

const HomePage = () => {
  return (
    <div>
      <Banner />
      <HeroSlider />
      {/* <Trucks /> */}
      <ThreeSDealership />
      <Headline />
      <Reviews />
      <Brands />
      <TrucksList />
      {/* <Fabricate /> */}
      <VideoSection />
    </div>
  );
};

export default HomePage;